import { FC } from 'react'
import BroadcastStats from 'component/Broadcast/BroadcastStats'
import BroadcastTabs from 'component/Broadcast/BroadcastTabs'
import BroadcastHeader from 'component/Broadcast/BroadcastHeader'

const BroadcastPageLayout: FC = () => {
	return (
		<>
			<BroadcastHeader />
			<BroadcastStats />
			<BroadcastTabs />
		</>
	)
}

export default BroadcastPageLayout
